import { loadAppFeatureFlags as loadOpsHubAppFeatureFlags } from '@telstra-connect/ops-hub/feature-flags/load-flags';

import global from '@applications'

export const setFeatureFlags = () => {
  const getFlagsConfigFromState = () => global.applications
  loadOpsHubAppFeatureFlags(getFlagsConfigFromState)
}
